export const cilVerticalAlignCenter = ["24 24","<path d='M16.318 6.155l-1.061-1.061-2.507 2.507v-6.852h-1.5v6.852l-2.507-2.507-1.061 1.061 4.318 4.318 4.318-4.318z'></path><path d='M0.75 11.25h22.5v1.5h-22.5v-1.5z'></path><path d='M7.682 17.845l1.061 1.061 2.507-2.507v6.852h1.5v-6.852l2.507 2.507 1.061-1.061-4.318-4.318-4.318 4.318z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-vertical-align-center.js
// module id = null
// module chunks = 